


import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {PayOrderShortDto, SplitBillDetailDto, SplitBillShortDto} from "@/api/appService";
import BillDetailReturnDetail from "@/views/pays/splitOrder/BillDetailReturnDetail.vue";

@Component({
  name: 'BillDetail',
  components: {BillDetailReturnDetail},
  filters:{
    formatAmount(cellValue: number){
      return '￥'+(cellValue / 100.0).toFixed(2)
    }
  }
})
export default class BillDetail extends Vue {


  visibleInternal = false;
  private _visible = false;


  loading = false;


  @Prop({required: false})
  detail?: SplitBillDetailDto;

  @Prop({required: true, default: false})
  visible!: boolean;

  @Watch('visible')
  watchVisible(newValue: boolean) {
    this.visibleInternal = newValue;
  }

  @Watch('visibleInternal')
  watchInternalVisible(newValue: boolean) {
    this.$emit('update:visible', newValue)
  }


  get payOrder(): PayOrderShortDto {
    return this.detail?.payOrder ?? {};
  }

  get bill(): SplitBillShortDto {
    return this.detail?.bill ?? {};
  }


}


